
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/power-kits",
      function () {
        return require("private-next-pages/calculators/power-kits/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/power-kits"])
      });
    }
  